import React from "react";
import { connect } from "react-redux";

import { setActiveDomain, showModal, fetchLifeSettlementChoices } from "actions";
import AdminPageHeader from "./AdminPageHeader";
import { RecordsTable } from "../../components/table";
import { Card } from "react-bootstrap";
import DomainsTable from "./domains/DomainsTable";
import { DOMAIN_MODAL } from "../../components/modals";
import DomainFilterForm from "./domains/DomainFilterForm";

const AdminReportsPage = props => {
  React.useEffect(() => {
    props.fetchLifeSettlementChoices();
    document.title = "LifeRoc | Admin Domains";
  }, []);

  return (
    <>
      <AdminPageHeader />
      <div className={`section-card shadowed case-section`} style={{ marginTop: "1.5rem" }}>
        <DomainFilterForm />
        <Card className={"case-info"}>
          <Card.Body>
            <RecordsTable
              title="Domains"
              createButtonLabel="Add Domain"
              onCreateClick={() => {
                props.setActiveDomain(null);
                props.showModal(DOMAIN_MODAL);
              }}
              Table={DomainsTable}
            />
            <br />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default connect(null, {
  showModal,
  setActiveDomain,
  fetchLifeSettlementChoices,
})(AdminReportsPage);
